// Injected at build time by scripts/deploy.sh from the stack outputs.
// API Gateway base URL (including the /Prod stage).
export const API_BASE = process.env.REACT_APP_API_BASE;

// Staff sign-in (Cognito user pool federated with Google).
export const AUTH = {
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  adminEmail: (process.env.REACT_APP_ADMIN_EMAIL || '').toLowerCase(),
};

// Hostnames that open the staff app at / (e.g. hkccapp.com,www.hkccapp.com). Any other host
// (apt.hkccapp.com, the CloudFront address) shows the patient chatbot at /, staff at /staff.
export const STAFF_HOSTNAMES = (process.env.REACT_APP_STAFF_HOSTNAMES || '').split(',').filter(Boolean);
